import React, { useEffect } from 'react';
// import { useHistory } from 'react-router-dom';

import { Link } from 'react-router-dom';
import { FcApproval } from 'react-icons/fc';
import HoaNavbar from '../HoaNavbar/HoaNavbar';
import HoaFooter from '../HoaFooter/HoaFooter';
import { FaArrowLeft } from "react-icons/fa6";

const HoaCall = () => {
  return (
    <div>
      <HoaNavbar />
      <div className="approval">
        <div className="w-[85%] h-screen mx-auto flex flex-col justify-center items-center bg-white">
          <div className="w-4/5 flex justify-start items-center mb-8 sm:mb-12">
            <Link
              to="/"
              className="no-underline text-xl sm:text-2xl font-extrabold text-blue-800 hover:text-blue-900 transition-colors"
            >
              <FaArrowLeft />
            </Link>
          </div>

          <div className="text-center mb-8 sm:mb-12">
            <FcApproval className="text-[120px] sm:text-[150px] md:text-[180px] lg:text-[200px] mx-auto" />
          </div>

          <div className="text-center px-4">
            <p className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-extrabold text-blue-800 leading-relaxed">
              We will contact you within 2 business days.
            </p>
          </div>
        </div>
      </div>
      <HoaFooter />
    </div>
  );
};

export default HoaCall;